// TODO UW-2735 this either need to be refactored or incorporated into the accordion work from coreComponent

import { isQuickshop } from '../../../product/js/utils/quickshopUtils';
import { isSpacePressed } from '@core/js/utils/keyUtils';

const COLLAPSED_CSS_CLASS = 'is-collapsed';
const EXPAND_ALL_SIZES = 'js-expand-all-sizes';
const EXPANDED_CSS_CLASS = 'is-expanded';
const TAB_SET_CLASS = '.js-accordion-tabset';

function collapseTabSet(tabSet, component) {
    const control = $(tabSet).find('.o-accordion__control');
    const panel = $(tabSet).find('.o-accordion__panel');
    const tab = $(tabSet).find('.o-accordion__tab');

    $(tabSet).addClass(COLLAPSED_CSS_CLASS);
    $(tabSet).removeClass(EXPANDED_CSS_CLASS);
    control.attr('title', getExpandToolTip(component));
    tab.attr('aria-expanded', 'false');
    panel.attr('aria-hidden', 'true');
}

function expandTabSet(tabSet, component) {
    const control = $(tabSet).find('.o-accordion__control');
    const panel = $(tabSet).find('.o-accordion__panel');
    const tab = $(tabSet).find('.o-accordion__tab');

    $(tabSet).addClass(EXPANDED_CSS_CLASS);
    $(tabSet).removeClass(COLLAPSED_CSS_CLASS);
    control.attr('title', getCollapseToolTip(component));
    tab.attr('aria-expanded', 'true');
    panel.attr('aria-hidden', 'false');
}

function canDetermineDeviceWidth(state) {
    if (state &&
        state.core &&
        state.core.deviceCharacteristics) {
        return true;
    }

    return false;
}

/**
 * Merge the tabstate from the user intent and the server load
 * @param {Object} store - the redux store
 * @param {String} templateString - the template this is about to be rendered
 * @return {jQuery|HTMLElement} a possibly modified template string
 */
export function mergeTabSetState(store, templateString) {
    const facetDom = $($.parseHTML(templateString.trim()));

    if (this.accordionState && _.isEmpty(this.accordionState)) {
        setInitialStateForTabSet.bind(this)();
        return templateString;
    }

    if (!_.isEmpty(facetDom)) {
        $.each(facetDom.find(this.jsAccordionClass), (index, tabSet) => {
            const el = $(tabSet);

            if (el && this.accordionState[el.attr(this.accordionNameDataAttr)]) {
                $(tabSet).removeClass('is-collapsed');
            }
            if (el && !this.accordionState[el.attr(this.accordionNameDataAttr)]) {
                $(tabSet).addClass('is-collapsed')
                    .removeClass('is-expanded');
            }
        });

        return $(facetDom).get(0).outerHTML;
    }

    return '';
}

/**
 * Sets the cache for expanded tabs on load from server
 */
export function setInitialStateForTabSet() {
    $.each($(this.jsAccordionClass), (index, tabSet) => {
        const el = $(tabSet);

        if (!el.hasClass('is-collapsed')) {
            const tabName = el.attr(this.accordionNameDataAttr);

            this.accordionState[tabName] = tabName;
        }
    });
}

/**
* Return state for accordions based on default accordion state.
* Respects hard coded 'is-collpased' class on tabSet first
* @param {array} tabSet         array of current accordion dom element
* @param {object} component     The component for which accordion support is being added
* @return {string} 'expand' or 'collapse'
*/
export function useDefaultPDPTabSetStates(tabSet, component) {
    const state = component.getState();

    if ($(tabSet).hasClass(COLLAPSED_CSS_CLASS)) {
        return 'collapse';
    } else if ($(tabSet).hasClass(EXPAND_ALL_SIZES)) {
        return 'expand';
    } else if (canDetermineDeviceWidth(state)) {
        const isQuickshopAccordion = isQuickshop(state);
        const isSmallish = _.get(state, 'core.deviceCharacteristics.is_smallish');

        if (isQuickshopAccordion || isSmallish) {
            return 'collapse';
        }
    }

    return 'expand';
}

function getExpandToolTip(component) {
    const state = component.getState();

    if (_.get(state, 'core.localizations.containers.chromeLocalization.accordion-tooltip_expand')) {
        return state.core.localizations.containers.chromeLocalization['accordion-tooltip_expand'];
    }

    return 'Expand';
}

function getCollapseToolTip(component) {
    const state = component.getState();

    if (_.get(state, 'core.localizations.containers.chromeLocalization.accordion-tooltip_collapse')) {
        return state.core.localizations.containers.chromeLocalization['accordion-tooltip_collapse'];
    }

    return 'Collapse';
}

export function defaultTabSetStateFunction(tabSet, component) {
    if ($(tabSet).hasClass(COLLAPSED_CSS_CLASS)) {
        return 'collapsed';
    }

    return 'expand';
}

/**
 * Is the given element with an accordion collapsed?
 * @param  {object}  el HTML element
 * @return {boolean}    True, if the accordion is collapsed; false, otherwise.
 */
export function isCollapsed(el) {
    const tabSet = el.closest(TAB_SET_CLASS);

    if (tabSet) {
        return tabSet[0].classList.contains(COLLAPSED_CSS_CLASS);
    }

    return false;
}

/**
 * Is the given element with an accordion collapsed?
 * @param  {object}  el HTML element
 * @return {boolean}    True, if the accordion is collapsed; false, otherwise.
 */
export function isExpanded(el) {
    const tabSet = el.closest(TAB_SET_CLASS);

    if (tabSet) {
        return tabSet[0].classList.contains(EXPANDED_CSS_CLASS);
    }

    return false;
}

/**
 * Close an accordion for a given selector
 * @param  {string} selector   Target accordion element selector to close
 * @param {object} component   The component for which accordion support is being added
 */
export function closeAccordionTab(selector, component) {
    const target = $(selector)[0];
    const e = {
        target
    };

    if (isExpanded(target)) {
        toggleAccordionTab(e, component);
    }
}

/**
 * Open an accordion for a given selector
 * @param  {string} selector   Target accordion element selector to open
 * @param {object} component   The component for which accordion support is being added
 */
export function openAccordionTab(selector, component) {
    const target = $(selector);
    const e = {
        target
    };
    if (isCollapsed(target)) {
        toggleAccordionTab(e, component);
    }
}

/**
 * Toggle an accordion given a selector
 * @param  {string} selector   Target accordion element selector
 * @param {object} component   The component for which accordion support is being added
 */
export function toggleAccordionSelector(selector, component) {
    const target = $(selector)[0];
    const e = {
        target
    };

    toggleAccordionTab(e, component);
}

export function toggleAccordionTab(event, component) {
    const tab = $(event.target);
    const tabSet = tab.closest(TAB_SET_CLASS);

    if (tabSet.length > 0) {
        const firstTabSet = $(tabSet[0]);

        firstTabSet.toggleClass(EXPANDED_CSS_CLASS);
        firstTabSet.toggleClass(COLLAPSED_CSS_CLASS);

        updateTabSetState(firstTabSet, component);
    }
}

export function showDefaultTabSetState(tabSet, component, defaultTabStateCallback) {
    if (defaultTabStateCallback) {
        let tabState = defaultTabStateCallback(tabSet, component);

        if (!tabState) {
            tabState = useDefaultPDPTabSetStates(tabSet, component);
        }

        if (tabState === 'expand') {
            expandTabSet(tabSet, component);
        } else if (tabState === 'collapse') {
            collapseTabSet(tabSet, component);
        }
    }
}

export function updateTabSetState(tabSet, component) {
    if ($(tabSet).hasClass(COLLAPSED_CSS_CLASS)) {
        collapseTabSet(tabSet, component);
    } else {
        expandTabSet(tabSet, component);
    }
}

export function bindAccordionChangeEvent() {
    $(document).off('ACCORDION_CHANGE');
    $(document).on('ACCORDION_CHANGE', (event, accordionClickEvent) => {
        const el = $(accordionClickEvent.currentTarget);
        const tabName = el.closest(this.jsAccordionClass).attr(this.accordionNameDataAttr);

        if (this.accordionState) {
            if (this.accordionState[tabName]) {
                delete this.accordionState[tabName];
            } else {
                this.accordionState[tabName] = tabName;
            }
        }
    });
}

/* eslint-disable no-shadow */
/**
 * Add Javascript functionality to all accordions on the page
 * @param {object} component                    The component for which accordion support is being added
 * @param {string} selectorRoot                 Root selector
 * @param {function} defaultTabStateCallback    Set default tab states
 */
export default function addAccordionSupport(
    component,
    selectorRoot,
    defaultTabStateCallback = defaultTabSetStateFunction) {
    $(`${selectorRoot} .js-accordion-tab`).each((index, tab) => {
        $(tab).parent()
            .off('click', '.js-accordion-tab');
        $(tab).parent()
            .on('click keydown', '.js-accordion-tab', (event) => {
                if (event.type === 'click' || isSpacePressed(event)) {
                    event.preventDefault();
                    toggleAccordionTab(event, component);
                    $(document).trigger('ACCORDION_CHANGE', event);
                }
            });

        const tabSet = $(tab).closest(TAB_SET_CLASS);
        showDefaultTabSetState(tabSet, component, defaultTabStateCallback);
    });
}
/* eslint-enable no-shadow */
